module.exports = __webpack_public_path__ + "static/media/answer3.a9c47223.svg";